import React from 'react';
import { UTLabel } from '@widergy/energy-ui';

import UTBullet from 'app/components/UTBullet';
import { appConfig } from 'config/customization';

import styles from './styles';

const OthersContent = () =>
  appConfig.changeDueDate.content.map(content => (
    <React.Fragment key={content.key}>
      <UTLabel bold style={styles.title}>
        {content.title}
      </UTLabel>
      {content.subtitle && (
        <UTLabel light small style={styles.subtitle}>
          {content.subtitle}
        </UTLabel>
      )}
      <div>
        {content.withBullet
          ? content.items.map(item => (
              <UTBullet content={item.content} base key={item.id} style={styles.bullets} />
            ))
          : content.items.map(item => (
              <div key={item.id} style={styles.itemContentContainer}>
                <UTLabel light small>
                  {item.content}
                </UTLabel>
              </div>
            ))}
      </div>
    </React.Fragment>
  ));

export default OthersContent;
